/* **************************************************** Project Progress Service */
export interface ProjectProgressService {
    id: number;
    type: 'Custom' | 'Default';
    service_name: string;
    created_by: number | null;
    status: 1 | 0;
}

export const mapProjectProgressService = (data: any): ProjectProgressService => {
    if (!data) {
        throw new Error("Invalid project progress service type");
    }

    const res: ProjectProgressService = {
        id: data.id,
        type: data.type,
        service_name: data.service_name,
        created_by: data.created_by,
        status: data.status,
    };

    return res;
};

export const mapProjectProgressServices = (data: any[]): ProjectProgressService[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid project progress service data");
    }

    return data.map(mapProjectProgressService);
};
/* **************************************************** */